import React from "react";
import { Box, Tooltip, useTheme } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useAccessControlHook } from "./accessControlHook";

const LOCK_TOOLTIP = "Upgrade your plan to unlock this feature";

const AccessControl = ({
  featureId,
  children,
  hasPermissions,
  alternateOption,
  showDeliberately,
  hideDeliberately,
  wrapperSx,
}) => {
  const theme = useTheme();
  let { hasPermissions: canAccess } = useAccessControlHook(featureId);

  if (typeof hasPermissions !== "undefined") {
    canAccess = hasPermissions;
  }

  const renderDisabled = () => (
    <Tooltip title={LOCK_TOOLTIP} arrow placement="top">
      <Box
        sx={{
          display: "inline-flex",
          position: "relative",
          cursor: "not-allowed",
          ...wrapperSx,
        }}
      >
        {/* Greyed child */}
        <Box sx={{ opacity: 0.65, pointerEvents: "none", filter: "grayscale(0.3)" }}>
          {children}
        </Box>

        {/* Frosted lock overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "inherit",
            backgroundColor: "rgba(255,255,255,0.25)",
            backdropFilter: "blur(1px)",
            pointerEvents: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.85)",
              border: "1px solid rgba(255,255,255,0.6)",
              boxShadow: "0 1px 6px rgba(0,0,0,0.10)",
              backdropFilter: "blur(2px)",
            }}
          >
            <LockOutlinedIcon
              sx={{
                fontSize: 11,
                color: theme.customColors?.text?.iconMuted || "#94A3B8",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Tooltip>
  );

  const getContent = () => {
    if (showDeliberately) return children;
    if (hideDeliberately) return null;
    if (canAccess === -1) return alternateOption || null;
    if (canAccess === 0) return renderDisabled();
    return children;
  };

  return <React.Fragment>{getContent()}</React.Fragment>;
};

export default AccessControl;
